(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6853],{

/***/ 25066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90359);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50866);
/* harmony import */ var _components_Trainings_Trainings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56350);
/* harmony import */ var _hooks_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85683);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40238);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);











var Trainings = function Trainings(_ref) {
  var trainings = _ref.trainings,
      trainingsCount = _ref.trainingsCount,
      cityFilters = _ref.cityFilters,
      monthFilters = _ref.monthFilters,
      packageFilters = _ref.packageFilters,
      categoryFilters = _ref.categoryFilters,
      personFilters = _ref.personFilters,
      filtersCount = _ref.filtersCount;

  var _useTranslations = (0,_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
      title: t('seo.courses.title'),
      description: "",
      noindex: !_constants__WEBPACK_IMPORTED_MODULE_6__/* .IS_PROD */ .XK,
      nofollow: !_constants__WEBPACK_IMPORTED_MODULE_6__/* .IS_PROD */ .XK
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Trainings_Trainings__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      trainings: trainings,
      count: trainingsCount,
      packageFilters: packageFilters,
      cityFilters: cityFilters,
      monthFilters: monthFilters,
      categoryFilters: categoryFilters,
      personFilters: personFilters,
      trainingFiltersCount: filtersCount
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Trainings);

/***/ }),

/***/ 24074:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kurzy",
      function () {
        return __webpack_require__(25066);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,354,5675,5897,6510,494,6350,9774,2888,179], function() { return __webpack_exec__(24074); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);